import React, {Component} from 'react';
import {TabContent, TabPane} from "reactstrap";
import {UserHierarchyManagementContainer} from "../UserHierarchyManagementContainer";
import {HttpRequest} from "../../util/http";

interface IHierarchyPermissionProps {
  defaultAvid: string
  request_UserId: string
  request_projectId: string
  coachingFormInheritValue: boolean
  notificationsInheritValue: boolean
}

interface IHierarchyPermissionState {
  activeTab: string
  tabs: ITab[]
  dashboardsAvidsList: IAvid[]
  coachingFormsAvidsList: IAvid[]
  notificationsAvidsList: IAvid[]
  dashboardsDefaultAvid: string
  coachingFormsDefaultAvid: string
  notificationsDefaultAvid: string
  dashboardsInheritCheckboxValue: boolean
  coachingFormsInheritCheckboxValue: boolean
  notificationsInheritCheckboxValue: boolean
  enableActionAlerts: boolean
}

interface ITab {
  value: string
  label: string
  isActive: boolean
}

export class HierarchyPermissionContainer extends Component<IHierarchyPermissionProps, IHierarchyPermissionState> {
  state: IHierarchyPermissionState = {
    activeTab: 'dashboards',
    tabs: [
      { value: 'dashboards', label: 'Dashboards', isActive: true },
      { value: 'coachingForms', label: 'Individual Surveys', isActive: false },
      { value: 'notifications', label: 'Notifications', isActive: false }
    ],
    coachingFormsAvidsList: [],
    coachingFormsDefaultAvid: '',
    coachingFormsInheritCheckboxValue: false,
    dashboardsAvidsList: [],
    dashboardsDefaultAvid: '',
    dashboardsInheritCheckboxValue: false,
    enableActionAlerts: false,
    notificationsAvidsList: [],
    notificationsDefaultAvid: '',
    notificationsInheritCheckboxValue: false,
  }

  componentDidMount() {
    this.setActionAlertVisibility();
  }

  updateTabs(activeTab: string) {
    let tabs = this.state.tabs;
    tabs.map((tab) => {
      tab.isActive = (tab.value == activeTab);
      return tab;
    });
    this.setState({
      tabs: tabs,
      activeTab: activeTab
    });
  }

  updateContainersList(container: string, AvidsList: IAvid[], defaultAvid: string, inheritCheckboxValue: boolean) {
    switch (container) {
      case 'dashboards':
        this.setState({dashboardsAvidsList: AvidsList, dashboardsDefaultAvid: defaultAvid, dashboardsInheritCheckboxValue: inheritCheckboxValue});
        break;
      case 'coachingForms':
        this.setState({coachingFormsAvidsList: AvidsList, notificationsDefaultAvid: defaultAvid, coachingFormsInheritCheckboxValue: inheritCheckboxValue});
        break;
      case 'notifications':
        this.setState({notificationsAvidsList: AvidsList, notificationsDefaultAvid: defaultAvid, notificationsInheritCheckboxValue: inheritCheckboxValue});
        break;
    }
    return;
  }

  setActionAlertVisibility() {
    const method = 'POST';
    HttpRequest.fetch<any>
    ('scripts/coaching_form/enableActionAlerts', {method})
      .then((enableActionAlerts) => {
        this.setState({enableActionAlerts: enableActionAlerts}, () => {
          if (enableActionAlerts) {
            this.setState({tabs: [
                { value: 'dashboards', label: 'Dashboards', isActive: true },
                { value: 'coachingForms', label: 'Individual Surveys and Action Alerts', isActive: false },
                { value: 'notifications', label: 'Notifications', isActive: false }
              ]})
          }
        });
      });
  }


  render() {
    const {defaultAvid, request_UserId, request_projectId, coachingFormInheritValue, notificationsInheritValue} = this.props
    return (
      <div>
        <div style={{padding: '15px 0px'}}><h5>Hierarchy Access</h5></div>
        <ul className="nav nav-tabs">
          {
            this.state.tabs.map((tab, idx) => {
              return (
                <li className="nav-item" key={idx}>
                  <a className={"nav-link" + (tab.isActive ? ' active' : '')} onClick={() => this.updateTabs(tab.value)}>{tab.label}</a>
                </li>
              );
            })
          }
        </ul>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="dashboards">
            <UserHierarchyManagementContainer
              defaultAvid = {defaultAvid}
              request_UserId = {Number(request_UserId)}
              request_Type = {'DASHBOARD'}
              request_projectId = {request_projectId}
              sectionName = {'Dashboards'}
              inheritCheckbox = {false}
              inheritMessage = {''}
              inheritCheckboxValue = {false}
              checkboxInputName = {''}
              liftUpAvidsList={(avidsList, defaultAvid, inheritCheckboxValue) => this.updateContainersList('dashboards', avidsList, defaultAvid, inheritCheckboxValue)}
            />
          </TabPane>
          <TabPane tabId="coachingForms">
            <UserHierarchyManagementContainer
              defaultAvid = {defaultAvid}
              request_UserId = {Number(request_UserId)}
              request_Type = {'COACHINGFORM'}
              request_projectId = {request_projectId}
              sectionName = {'Coaching Forms'}
              inheritCheckbox = {true}
              inheritMessage = {'Inherit Dashboard Hierarchy Access'}
              inheritCheckboxValue = {coachingFormInheritValue}
              checkboxInputName = {'s_cf_use_dashboard_avids'}
              liftUpAvidsList={(avidsList, defaultAvid, inheritCheckboxValue) => this.updateContainersList('coachingForms', avidsList, defaultAvid, inheritCheckboxValue)}
            />
          </TabPane>
          <TabPane tabId="notifications">
            <UserHierarchyManagementContainer
              defaultAvid = {defaultAvid}
              request_UserId = {Number(request_UserId)}
              request_Type = {'NOTIFICATIONS'}
              request_projectId = {request_projectId}
              sectionName = {'Notifications'}
              inheritCheckbox = {true}
              inheritMessage = {'Inherit Individual Survey Access Hierarchy'}
              inheritCheckboxValue = {notificationsInheritValue}
              checkboxInputName = {'s_n_use_dashboard_avidz'}
              liftUpAvidsList={(avidsList, defaultAvid, inheritCheckboxValue) => this.updateContainersList('notifications', avidsList, defaultAvid, inheritCheckboxValue)}
            />
          </TabPane>
        </TabContent>
      </div>
    );
  }
}